import Navbar from "../../components/Navbar";
import MapBrowsing from "../../components/client/home/MapBrowsing";

export default function MapBrowser() {
  return (
    <Navbar>
      <MapBrowsing />
    </Navbar>
  );
}
